import { useEffect, useState } from "react";
import { fetchProgramOrganizers, fetchPrograms } from "../api/programs";

/**
 * Program + Hosted By filter state used by Event Management and Event Dashboard metrics.
 * Hosted By options load only after a program is selected (same as Events).
 */
export function useEventProgramHostedByFilters({ account_id } = {}) {
  const [programs, setPrograms] = useState([]);
  const [filterProgramId, setFilterProgramId] = useState("");
  const [filterOrganizerId, setFilterOrganizerId] = useState("");
  const [filterProgramMembers, setFilterProgramMembers] = useState([]);

  useEffect(() => {
    if (!account_id) {
      setPrograms([]);
      return undefined;
    }
    let cancelled = false;
    fetchPrograms({ account_id })
      .then((data) => {
        if (!cancelled) setPrograms(data);
      })
      .catch(() => {
        if (!cancelled) setPrograms([]);
      });
    return () => {
      cancelled = true;
    };
  }, [account_id]);

  useEffect(() => {
    const gid = (filterProgramId || "").trim();
    if (!account_id || !gid) {
      setFilterProgramMembers([]);
      if (!gid) setFilterOrganizerId("");
      return undefined;
    }
    let cancelled = false;
    fetchProgramOrganizers({ account_id, program_id: gid })
      .then((data) => {
        if (!cancelled) setFilterProgramMembers(data);
      })
      .catch(() => {
        if (!cancelled) setFilterProgramMembers([]);
      });
    return () => {
      cancelled = true;
    };
  }, [account_id, filterProgramId]);

  return {
    programs,
    filterProgramId,
    setFilterProgramId,
    filterOrganizerId,
    setFilterOrganizerId,
    filterProgramMembers,
  };
}
